export default {
    AccessRequestSubmmited: 'Your access request has been successfully submitted. You will be notified within 1 business day.',
    AccessRequestPending: 'Your access request is pending approval. Please contact IBC Youth at 800-514-2695, ext. 8426 if it has been more than two business days since you submitted your request.',
    PendingAccessRequest: 'Access Request Status',
    CompleteAccessRequest: 'Complete your access request',
    MismatchInfo: 'The member information you entered does not match your profile.',
    InvalidId: 'Invalid membership Id. Please try again.',
    MissingMemberId: 'Please enter your USBC Membership Id in the fields (separated by the dash) below and your birthday',
    EnterInfo: 'Enter your USBC membership Id to request access to the portal.',
    RequestAccess: 'Request Junior Gold Portal Access',
    EmailMissing: 'The request for access cannot be processed because your membership profile is missing an email address.  Please contact tournaments@ibcyouth.com or 800-514-2695 x8426 to update.'
}


// WEBPACK FOOTER //
// ./src/containers/userregistration/logic/userMessages.js